import * as THREE from "three";

// 카메라 생성 및 종회비 위치, 각도 옵션 설정
export function createCamera(container) {
  // 종횡비(aspect) = 컨테이너의 가로/세로
  const aspect = container.clientWidth / container.clientHeight;

  // 원근 카메라 생성 (fov 60도, 근/원거리 클리핑: 0.1 ~ 1000)
  const camera = new THREE.PerspectiveCamera(60, aspect, 0.1, 1000);

  // 카메라 위치 (x,y,z)
  camera.position.set(0, 0, 1);

  return camera;
}
